module.exports = __webpack_public_path__ + "static/media/shipping.d6709d15.svg";